module.exports = __webpack_public_path__ + "static/media/urbangoo15.6d8faf7b.webp";